import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-4 pa-4 fill-height" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, null, -1)

import AButtonSecondary from '@/components/atoms/AButtonSecondary.vue'
	import ATabs from '@/components/atoms/ATabs.vue'
	import MNoData from '@/components/molecules/MNoData.vue'
	import MFilters from '@/components/molecules/MFilters.vue'
	import TConfirmation from '@/components/templates/TConfirmation.vue'
	import TheColumns from '@/components/TheColumns.vue'
	import AgDatatable from '@/components/datatable/AgDatatable.vue'
	import DefaultCellRenderer from '@/components/datatable/cellRenderers/DefaultCellRenderer.vue'
	import ActionsCellRenderer from '@/components/datatable/cellRenderers/ActionsCellRenderer.vue'

	import type { ObjectContext } from '@/global'
	import { reactive, computed, watch } from 'vue'
	import { useGeneral, useDatatable, useMainView } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const { $store, $router, $route, icons, tabSelected, loading } = useGeneral()
	const { emitReload, isCellEditable, suppressEnter, valueSetter } = useDatatable()

	const state = reactive({
		confirmDialog: false,
		confirmDelete: false,
		confirmCopy: false,
		tab: '',
		itemSelected: {}
	})

	const { items, menuTabs, changeTab, init, pagination } = useMainView(state)

	const tabSelectedElement = computed(() => $store.getters['roles/GET_TAB_ELEMENTS'][tabSelected.value])

	init(true)

	watch(tabSelected, val => {
		if (val !== state.tab) changeTab(val)
	})

	watch(
		() => $route.params.tab,
		val => {
			if (val !== state.tab) changeTab(val, true)
		}
	)

	const itemIdKey = computed(() => $store.getters['GET_ITEM_ID_KEY'][tabSelected.value] || '')

	function viewClick(item: ObjectContext) {
		console.log(`🚀 ~ viewClick`, item)
		const key: string = itemIdKey.value
		const routeName = $route.name + '_edit'
		$router.push({
			name: routeName,
			params: {
				tab: tabSelected.value,
				id: item[key]
			}
		})
	}

	async function copyClick(item?: ObjectContext) {
		console.log(`🚀 ~ copyClick`, item)
		if (tabSelected.value === 'warehouse_evaluations') {
			if (item) {
				state.confirmCopy = true
				state.confirmDelete = false
				state.itemSelected = Object.assign({}, item)
				state.confirmDialog = !state.confirmDialog
			} else {
				loading.value = true
				try {
					const body = Object.assign({}, state.itemSelected)
					await $store.dispatch('cloneItem', body)
					init(true)
				} catch (error) {
					loading.value = false
					$store.dispatch('alert/SET_ALERT', { action: 'copy', error })
				}
			}
		} else {
			const key: string = itemIdKey.value
			const routeName = $route.name + '_copy'
			$router.push({
				name: routeName,
				params: {
					tab: tabSelected.value,
					// @ts-ignore
					id: item[key]
				}
			})
		}
	}

	async function deleteClick(item?: ObjectContext) {
		console.log(`🚀 ~ deleteClick ~ item`, item)
		if (item) {
			state.confirmCopy = false
			state.confirmDelete = true
			state.itemSelected = Object.assign({}, item)
			state.confirmDialog = !state.confirmDialog
		} else {
			loading.value = true
			const item = Object.assign({}, state.itemSelected)
			state.itemSelected = {}

			const action = 'delete'

			try {
				await $store.dispatch(`${tabSelected.value}/delete`, item)
				$store.dispatch('alert/SET_ALERT', { action, color: 'success' })
			} catch (error) {
				$store.dispatch('alert/SET_ALERT', { action, error })
			} finally {
				init()
			}
		}
	}

	// @ts-ignore
	const columns: Array<string> = computed(() => {
		const items = JSON.parse(JSON.stringify($store.getters['filters/GET_SELECTED_COLUMNS'][tabSelected.value] || []))
		items.unshift('actions')
		return items
	})
	// @ts-ignore
	const headers: Array<ObjectContext> = computed(() => {
		// @ts-ignore
		return columns.value.map((key: string) => {
			return {
				mainTable: true,
				headerName: key,
				field: key,
				resizable: true,
				width: key === 'actions' ? 100 : '',
				pinned: key === 'actions' ? 'left' : '',
				sortable: key !== 'actions',
				// editable: isCellEditable(key),
				editable: false,
				cellEditor: 'DefaultCellEditor',
				cellRenderer: key === 'actions' ? ActionsCellRenderer : DefaultCellRenderer,
				cellRendererParams: {
					items: items.value,
					viewClick,
					copyClick,
					deleteClick
				},
				suppressKeyboardEvent: (params: ObjectContext) => suppressEnter(params),
				valueSetter: (params: ObjectContext) => valueSetter(params, tabSelected.value)
			}
		})
	})

	function onChangeFilters(filters: ObjectContext) {
		init()
	}

	function onChangeColumns(columns: ObjectContext) {
		init()
	}

	function onShowImport() {
		const route = $router.resolve({
			name: 'import',
			params: {
				tab: tabSelected.value
			}
		})
		window.open(route.href)
	}

	const user = computed(() => $store.getters['auth/USER'])
	const userColumns = computed(() => user.value['_columns'] || {})

	function onColumnMoved(columns: Array<ObjectContext>) {
		const newColumns = Object.assign({}, userColumns.value)
		newColumns[tabSelected.value] = columns.filter(e => e.field !== 'actions').map(e => e.field)
		const newUser = Object.assign({}, user.value)
		newUser['_columns'] = newColumns
		const body = {
			person_id: newUser.person_id,
			_item: newUser,
			_keys: ['_columns']
		}
		$store.dispatch('persons/update', body)
		$store.commit('auth/SET_USER', newUser)
	}

	function onUpdatePageNumber(page_number: number) {
		const newPagination = Object.assign({}, pagination.value)
		// @ts-ignore
		newPagination.page_number = page_number
		$store.commit('SET_PAGINATION', newPagination)
		init()
	}

	function onUpdateItemsPerPage(items_per_page: number) {
		const newPagination = Object.assign({}, pagination.value)
		// @ts-ignore
		newPagination.items_per_page = items_per_page
		newPagination.page_number = 1
		$store.commit('SET_PAGINATION', newPagination)
		init()
	}

	function onSortChanged(sort_columns: ObjectContext) {
		$store.commit('filters/SET_SORT_COLUMNS', sort_columns)
		init()
	}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ATabs, {
        modelValue: _unref(state).tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tab) = $event)),
        items: _unref(menuTabs),
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeTab)($event, true, true)))
      }, null, 8, ["modelValue", "items"]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }),
          _createVNode(_component_v_col, {
            cols: "6",
            class: "text-right"
          }, {
            default: _withCtx(() => [
              _createVNode(MFilters, {
                "tab-selected": _unref(tabSelected),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (onChangeFilters($event)))
              }, null, 8, ["tab-selected"]),
              _hoisted_2,
              _createVNode(TheColumns, {
                "tab-selected": _unref(tabSelected),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (onChangeColumns($event)))
              }, null, 8, ["tab-selected"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (!_unref(items).length)
                ? (_openBlock(), _createBlock(MNoData, {
                    key: 0,
                    "tab-selected": _unref(tabSelected),
                    "main-table": ""
                  }, null, 8, ["tab-selected"]))
                : (_openBlock(), _createBlock(AgDatatable, {
                    key: 1,
                    headers: _unref(headers),
                    items: _unref(items),
                    pagination: _unref(pagination),
                    onColumnMoved: _cache[4] || (_cache[4] = ($event: any) => (onColumnMoved($event))),
                    onUpdatePageNumber: _cache[5] || (_cache[5] = ($event: any) => (onUpdatePageNumber($event))),
                    onUpdateItemsPerPage: _cache[6] || (_cache[6] = ($event: any) => (onUpdateItemsPerPage($event))),
                    onSortChanged: _cache[7] || (_cache[7] = ($event: any) => (onSortChanged($event)))
                  }, null, 8, ["headers", "items", "pagination"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(TConfirmation, {
      modelValue: _unref(state).confirmDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).confirmDialog) = $event)),
      "confirm-delete": _unref(state).confirmDelete,
      "confirm-copy": _unref(state).confirmCopy,
      element: _unref(tabSelectedElement),
      onDelete: _cache[9] || (_cache[9] = ($event: any) => (deleteClick())),
      onCopy: _cache[10] || (_cache[10] = ($event: any) => (copyClick()))
    }, null, 8, ["modelValue", "confirm-delete", "confirm-copy", "element"])
  ], 64))
}
}

})